export default __webpack_public_path__ + "static/internationalolympiad2019teamsingapore-39ffa0716284e16842500e233d76afaa.jpg";